import {useEffect, useState}from "react";
import Hero from "../components/Hero";
import "../styles/Home.css";
import CardList from "../components/CardList";
import { getABCollections } from "../lib/artblocks.ts";

const Home = () => {
  const [upcomingCollections, setUpcomingCollections] = useState([]);
  const [openCollections, setOpenCollections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async() => {
      try {
        setIsLoading(true);
        setError(null);
        const collections = await getABCollections();
        const now = Date.now();
        
        // Filter for active, incomplete projects (potential for minting)
        const activeIncomplete = collections.filter(
          (collection) => !collection.complete && collection.active
        );
        
        // Upcoming: Projects that haven't started minting yet
        // - Has a future minting date, OR
        // - Is paused and hasn't been activated, OR
        // - No minting date and no invocations (never minted)
        setUpcomingCollections(
          activeIncomplete.filter((collection) => {
            const mintingDate = collection.mintingDate;
            const hasStarted = mintingDate && mintingDate * 1000 <= now;
            const hasMinted = collection.invocations > 0;
            
            // Upcoming if:
            // 1. Has future minting date, OR
            // 2. No minting date + no invocations + not activated (truly upcoming), OR
            // 3. Is paused with future minting date
            if (mintingDate && mintingDate * 1000 > now) {
              return true; // Minting hasn't started yet
            }
            if (!mintingDate && !hasMinted && !collection.activatedAt) {
              return true; // Never set up for minting
            }
            return false;
          })
        );
        
        // Open: Projects that are currently available for minting
        // - Not paused, AND
        // - Either minting date has passed OR has been activated, AND
        // - Not complete
        setOpenCollections(
          activeIncomplete.filter((collection) => {
            const mintingDate = collection.mintingDate;
            const hasStarted = mintingDate && mintingDate * 1000 <= now;
            const hasMinted = collection.invocations > 0;
            
            // Must not be paused to be "open"
            if (collection.paused) {
              return false;
            }
            
            // Open if:
            // 1. Minting date has passed, OR
            // 2. No minting date but has been activated (or has invocations)
            if (hasStarted) {
              return true;
            }
            if (!mintingDate && (collection.activatedAt || hasMinted)) {
              return true;
            }
            return false;
          })
        );
      } catch (err) {
        console.error("Error loading collections:", err);
        setError("Failed to load collections. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  if (isLoading) {
    return (
      <div id="home">
        <Hero />
        <div style={{textAlign: 'center', padding: '50px'}}>Loading collections...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div id="home">
        <Hero />
        <div style={{textAlign: 'center', padding: '50px', color: 'red'}}>{error}</div>
      </div>
    );
  }

  return (
    <div id="home">
      <Hero/>
      <p id="card-list-header-text"> Upcoming </p>
      <div id="list-container">
        <CardList collections={upcomingCollections} type={"collection"}/>
      </div>
      <p id="card-list-header-text"> Open </p>
      <div id="list-container">
        <CardList collections={openCollections} type={"collection"}/>
      </div>
    </div>
  );
};

export default Home;
